import {
  spacing,
  fontSize,
  borderRadius,
  fontWeight,
  mediaMax,
} from 'presentations/views/styles';
import Image from 'presentations/views/components/atoms/Image';
import Link from 'presentations/views/components/atoms/Link';
import styled from '@emotion/styled';
import { FeatureListItem } from 'presentations/api/schema/contents';
import { black, gray01 } from 'presentations/views/styles/color';
import { featurePath } from 'presentations/routes/path';

interface Props {
  feature: FeatureListItem;
}

export default function Component(props: Props) {
  const url = props.feature.redirectUrl || featurePath(props.feature.slug);
  return (
    <RelatedFeatureListItem key={props.feature.id}>
      {props.feature.thumbnailUrl && (
        <FeatureImageContainer>
          <Link href={url}>
            <FeatureImage
              src={props.feature.thumbnailUrl}
              alt={props.feature.name}
              width={300}
              height={300}
              dpr={2}
            />
          </Link>
        </FeatureImageContainer>
      )}
      <Content>
        <FeatureName href={url}>{props.feature.name}</FeatureName>
        <FeatureSummary>{props.feature.summary}</FeatureSummary>
      </Content>
    </RelatedFeatureListItem>
  );
}

const RelatedFeatureListItem = styled.div`
  display: flex;
  justify-content: space-between;
  ${mediaMax.tablet} {
    width: 100%;
    display: block;
  }
`;
const FeatureImageContainer = styled.div`
  width: 300px;
  margin-right: ${spacing(16)};
  ${mediaMax.tablet} {
    width: 100%;
    margin-right: 0;
    margin-bottom: ${spacing(16)};
  }
`;
const Content = styled.div`
  flex: 1;
`;
const FeatureImage = styled(Image)`
  width: 100%;
  height: auto;
`;
const FeatureName = styled(Link)`
  display: inline-block;
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(18)};
  margin-bottom: ${spacing(8)};
  color: ${black};
  ${mediaMax.tablet} {
    font-size: ${fontSize(14)};
  }
`;
const FeatureSummary = styled.p``;
